import React from 'react';
import { Modal } from 'react-bootstrap';
import './basicErrorModal.scss';
import IconClose from 'assets/icons/icon-close.svg';
import IconWarning from 'assets/icons/warning.svg';
import { formatText } from 'core/i18n';
const BasicErrorModal = ({ info, showModal, callback, closeModal }) => {
    const handleClose = () => {
        if (callback === 'recharge') {
            window.location.href = '/';
        } else {
            closeModal();
        }
    };
    return (
        <Modal show={showModal} dialogClassName={'error__modal__container'}>
            <div className="error__modal-heading">
                <div className="error__modal-heading__close-icon">
                    <img src={IconClose} onClick={handleClose} />
                </div>
                <h4>{info ? formatText(info.titleTextKey) : ''}</h4>
            </div>
            <div className="error__modal-content">
                <div className="error__modal-iconBox">
                    <img src={IconWarning} />
                </div>

                <p>{info ? formatText(info.infoTextKey) : ''}</p>
            </div>

            <div className="error__modal-buttons">
                <button className="form__button form__button-secondary" onClick={handleClose}>
                    {info ? formatText(info.buttonTextKey) : ''}
                </button>
            </div>
        </Modal>
    );
};

export default BasicErrorModal;
